import gql from 'graphql-tag'

export const QUERY_TRANSLATIONS = gql`
  query translations($locale: LocaleInputType!) {
    Translations(locale: $locale, limit: 0, draft: false) {
      totalDocs
      docs {
        key
        value
      }
    }
  }
`
